import React from "react";
import RadioInput from "components/RadioInput";
import {
  readingOrderLabel,
  readingOrderTraditional,
  readingOrderHistorical,
  readingOrderChronological,
} from "../messages";
import "./ReadingOrderSelector.css";

const ReadingOrderSelector = ({ readingOrder, setReadingOrder }) => {
  const handleRadioChange = (event) => {
    setReadingOrder(event.target.value);
  };

  return (
    <div className="reading-order-selector">
      <label className="input-label">{readingOrderLabel}</label>
      <div className="reading-order-options">
        <RadioInput
          id="traditional"
          name="readingOrder"
          value="traditional"
          checked={readingOrder === "traditional"}
          onChange={handleRadioChange}
          label={readingOrderTraditional}
        />
        <RadioInput
          id="historical"
          name="readingOrder"
          value="historical"
          checked={readingOrder === "historical"}
          onChange={handleRadioChange}
          label={readingOrderHistorical}
        />
        <RadioInput
          id="chronological"
          name="readingOrder"
          value="chronological"
          checked={readingOrder === "chronological"}
          onChange={handleRadioChange}
          label={readingOrderChronological}
        />
      </div>
    </div>
  );
};

export default ReadingOrderSelector;
